import { render } from "./SimpImageUpload.vue?vue&type=template&id=22b7989e&scoped=true&ts=true"
import script from "./SimpImageUpload.vue?vue&type=script&lang=ts"
export * from "./SimpImageUpload.vue?vue&type=script&lang=ts"

import "./SimpImageUpload.vue?vue&type=style&index=0&id=22b7989e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b7989e"]])

export default __exports__